import * as v from 'valibot';
import { transformedImageSizeMapSchema } from '../image/schema';
import { BaseOfferSchema } from './base';
import { TransformedOfferDetailsSchema } from './transformMarketplaceEntity';
import {
  TRANSFORMED_OFFER_ENTITY_KEYS,
  transformToCreditCardOffer,
} from './transformToCreditCardOffer';

const transformedOfferEntityFields = v.pick(BaseOfferSchema, TRANSFORMED_OFFER_ENTITY_KEYS);

export const TransformedOfferSchema = v.object({
  ...transformedOfferEntityFields.entries,
  driverIntroApr: v.nullish(BaseOfferSchema.entries.driverIntroApr),
  driverRegularApr: v.nullish(BaseOfferSchema.entries.driverRegularApr),
  driverRewardRate: v.nullish(BaseOfferSchema.entries.driverRewardRate),
  details: TransformedOfferDetailsSchema,
  imageOptions: transformedImageSizeMapSchema,
});
export const TransformedOffersSchema = v.array(TransformedOfferSchema);

export const OfferSchema = v.pipe(BaseOfferSchema, v.transform(transformToCreditCardOffer));

export const OffersSchema = v.array(OfferSchema);

export const OffersResponseSchema = v.object({
  data: v.object({
    marketplaceSearch: v.object({
      entities: v.array(OfferSchema),
    }),
  }),
});
